import { DatePipe } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { ToastService } from '../../../../services/toast.service';
import { TransferenciaInsumos } from '../../../../types/TransferenciaInsumos.type';
import { Table } from 'primeng/table';
import { TransferenciaInsumosService } from './transferencia-insumos.service';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-transferencia-insumos',
  templateUrl: './transferencia-insumos.component.html',
  styleUrl: './transferencia-insumos.component.css',
  providers: [DatePipe],
})
export class TransferenciaInsumosComponent {
  @ViewChild('dt') table!: Table;
  iconeCheckbox: string = "Nenhum"

  quantidadePorPagina: number = 20;
  totalRecords: number = 0;
  status: any[] = [
    { name: 'Integrado', value: 'INTEGRADO' },
    { name: 'Pendente Integração', value: 'NAO_INTEGRADO' },
    { name: 'Erro', value: 'ERRO' }
  ]

  itensExportacao: MenuItem[] = [];

  transferencias: TransferenciaInsumos[] = [];
  loading: boolean = false;
  instanciaSelecionada!: string;
  rangeDates!: string;
  transferenciasSelecionadas: TransferenciaInsumos[] = []

  tentativasHabilitado: boolean = false;

  todosRegistrosSelecionados: boolean = false;
  selecionados: boolean = false;

  constructor(
    private transferenciaService: TransferenciaInsumosService,
    private toastService: ToastService,
    private datePipe: DatePipe
  ) {
    this.itensExportacao = [
      {
        label: 'Exportar Selecionados',
        icon: 'pi pi-check-square',
        class: 'text-sm',
        command: () => {
          this.exportarSelecionados();
        },
      }
    ];
  }

  ngOnInit(): void {
    this.verificarTentativasHabilitado();
  }

  verificarTentativasHabilitado() {
    this.transferenciaService.getTentativasHabilitado().subscribe({
      next: () => {
        this.tentativasHabilitado = true;
        this.status.push({ name: 'Tentativas Excedida', value: 'TENTA_EXCEDIDA' });
      },
      error: (error) => {
        if (error.status === 409) {
          this.tentativasHabilitado = false;
        }
      }
    });
  }

  onLazyLoad(event: any) {
    if (
      this.instanciaSelecionada == undefined ||
      this.rangeDates == undefined ||
      !this.rangeDates[0] ||
      !this.rangeDates[1]
    ) {
      this.transferencias = [];
      this.totalRecords = 0;
      return;
    }

    this.loading = true;
    const sortDirection = event.sortOrder === 1 ? 'asc' : 'desc';
    const sortField = event.sortField || 'idTransf';
    const filtroStatusInteg = event.filters?.['fgStatusInteg'];
    const fgStatusInteg = Array.isArray(filtroStatusInteg) ? filtroStatusInteg[0]?.value : filtroStatusInteg?.value;
    const search = event.globalFilter || undefined;

    let dataInicial = this.getDataPipeTransForm(this.rangeDates[0]);
    let dataFinal = this.getDataPipeTransForm(this.rangeDates[1]);

    this.transferenciaService
      .getTransferencias(
        event.first / event.rows,
        event.rows,
        sortField,
        sortDirection,
        this.instanciaSelecionada,
        dataInicial,
        dataFinal,
        fgStatusInteg,
        search
      )
      .subscribe({
        next: (data) => {
          this.transferencias = data.content;
          this.totalRecords = data.totalElements;
          this.transferenciasSelecionadas = [];
        },
        error: (error) => {
          this.loading = false;
          this.toastService.erro(
            'Erro',
            'Erro ao buscar as informações: ' + error.error.message
          );
        },
        complete: () => {
          this.loading = false;
        },
      });
  }

  recarregar() {
    if (
      this.instanciaSelecionada == undefined ||
      this.rangeDates == undefined ||
      !this.rangeDates[0] ||
      !this.rangeDates[1]
    ) {
      this.toastService.alerta('Filtros', 'Informe os filtros necessários');
      return;
    }

    if (this.table) {
      this.table.first = 0;
      this.onLazyLoad({
        first: 0,
        rows: this.table.rows || 20,
        sortField: this.table.sortField || 'idTransf',
        sortOrder: this.table.sortOrder || 1,
        filters: this.table.filters,
        globalFilter: this.table.filters?.['global'] ? (this.table.filters['global'] as any).value : null
      });
    }
  }

  getDataPipeTransForm(data: string): string | null {
    return this.datePipe.transform(data, 'yyyy-MM-dd');
  }

  exportarSelecionados() {
    if (
      this.instanciaSelecionada == undefined
    ) {
      this.toastService.alerta('Instância', 'Selecione uma instância');
      return;
    }

    if (this.rangeDates == undefined) {
      this.toastService.alerta('Período', 'Selecione o período');
      return;
    }

    if (this.transferenciasSelecionadas.length === 0) {
      this.toastService.info("Exportar", 'Necessário selecionar os registros que devem ser exportados');
      return;
    }

    this.loading = true;
    let ids = this.transferenciasSelecionadas.map(m => m.idTransf)

    this.transferenciaService
      .exportarTransferenciasSelecionadas(ids)
      .subscribe({
        next: (value) => {
          const url = window.URL.createObjectURL(value);
          const a = document.createElement('a')
          a.href = url
          a.download = 'transferencias-insumos-selecionadas.xlsx'
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          this.toastService.sucesso("Exportar", `${ids.length} registros exportados com sucesso`);
        },
        error: (error) => {
          this.toastService.erro("Exportar", 'Erro ao exportar: ' + error.error);
        },
        complete: () => {
          this.loading = false;
        },
      });
  }

  exportarTodos() {
    if (
      this.instanciaSelecionada == undefined
    ) {
      this.toastService.alerta('Instância', 'Selecione uma instância');
      return;
    }

    if (this.rangeDates == undefined || !this.rangeDates[0] || !this.rangeDates[1]) {
      this.toastService.alerta('Período', 'Selecione o período');
      return;
    }

    this.loading = true;
    let dataInicial = this.getDataPipeTransForm(this.rangeDates[0]);
    let dataFinal = this.getDataPipeTransForm(this.rangeDates[1]);

    this.transferenciaService
      .exportarTodasTransferencias(this.instanciaSelecionada, dataInicial, dataFinal)
      .subscribe({
        next: (value) => {
          const url = window.URL.createObjectURL(value);
          const a = document.createElement('a')
          a.href = url
          a.download = 'transferencias-insumos-todas.xlsx'
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          this.toastService.sucesso("Exportar", `Todos os registros do filtro foram exportados com sucesso`);
        },
        error: (error) => {
          this.toastService.erro("Exportar", 'Erro ao exportar: ' + error.error);
        },
        complete: () => {
          this.loading = false;
        },
      });
  }

  selecionarRegistros(event: any) {
    if (event.checked) {
      if (!this.table) return;
      if (this.transferencias.length > 0) {

        let dadosFiltradosOrdenados = this.table.filteredValue || this.table.value

        const primeiroRegistro = this.table.first ?? 0;
        const linhasPorPagina = this.table.rows ?? 0;
        const ultimoRegistro = Math.min((primeiroRegistro + linhasPorPagina), this.transferencias.length);

        dadosFiltradosOrdenados = dadosFiltradosOrdenados.slice(primeiroRegistro, ultimoRegistro);

        this.transferenciasSelecionadas = this.transferenciasSelecionadas.filter(transf => !dadosFiltradosOrdenados.includes(transf))
        this.transferenciasSelecionadas = [...this.transferenciasSelecionadas, ...dadosFiltradosOrdenados]
      }

    } else {

      if (this.transferenciasSelecionadas.length == this.transferencias.length) {
        this.transferenciasSelecionadas = []
      } else {
        // Limpa apenas os registros visiveis na pagina atual
        let dadosFiltradosOrdenados = this.table.filteredValue || this.table.value

        const primeiroRegistro = this.table.first ?? 0;
        const linhasPorPagina = this.table.rows ?? 0;
        const ultimoRegistro = Math.min((primeiroRegistro + linhasPorPagina), this.transferencias.length);

        dadosFiltradosOrdenados = dadosFiltradosOrdenados.slice(primeiroRegistro, ultimoRegistro)
        this.transferenciasSelecionadas = this.transferenciasSelecionadas.filter(transf => !dadosFiltradosOrdenados.includes(transf))
      }
    }
    this.defineIconeCheckBox()
  }

  defineIconeCheckBox() {
    if (!this.table) return;

    if (this.transferencias.length > 0) {
      let dadosFiltradosOrdenados = this.table.filteredValue || this.table.value

      const primeiroRegistro = this.table.first ?? 0;
      const linhasPorPagina = this.table.rows ?? 0;
      const ultimoRegistro = Math.min((primeiroRegistro + linhasPorPagina), this.transferencias.length);

      const resultado = this.compareArrays(dadosFiltradosOrdenados.slice(primeiroRegistro, ultimoRegistro), this.transferenciasSelecionadas);

      if (this.transferenciasSelecionadas.length == dadosFiltradosOrdenados.length || this.transferenciasSelecionadas.length == this.transferencias.length) this.iconeCheckbox = "Todos"
      else if (resultado != "Nenhum") this.iconeCheckbox = "Parcial"

      else this.iconeCheckbox = "Nenhum"

      if (this.iconeCheckbox !== "Nenhum") this.selecionados = true
      else this.selecionados = false

    } else {
      this.iconeCheckbox = "Nenhum"
      this.selecionados = false
    }
  }

  onPageChange(event: any) {
    setTimeout(() => {
      this.defineIconeCheckBox();
    }, 0);
  }

  compareArrays<T>(arrayA: T[], arrayB: T[]): 'Todos' | 'Parcial' | 'Nenhum' {
    if (arrayA.length === 0) return 'Nenhum';

    const setB = new Set(arrayB);
    const countInB = arrayA.filter(item => setB.has(item)).length;

    if (countInB === 0) return 'Nenhum';
    if (countInB === arrayA.length) return 'Todos';
    return 'Parcial';
  }

  onSelectionChange() {
    setTimeout(() => {
      this.defineIconeCheckBox();
    }, 0);
  }

  onFilter(event: any) {
    setTimeout(() => {
      this.defineIconeCheckBox();
    }, 0);
  }

  selecionarTodos() {
    this.transferenciasSelecionadas = [...this.transferencias]
    this.defineIconeCheckBox()
  }

  reenviar() {
    if (this.transferenciasSelecionadas.length === 0) {
      this.toastService.info('Reenviar', 'Necessário selecionar os registros que devem ser reenviados');
      return;
    }

    const possuiStatusInvalido = this.transferenciasSelecionadas.some(t => t.fgStatusInteg !== 'TENTA_EXCEDIDA');

    if (possuiStatusInvalido) {
      this.toastService.alerta('Reenviar', 'Selecione apenas registros com status "Tentativas Excedida"');
      return;
    }

    const ids = this.transferenciasSelecionadas.map(t => t.idTransf);

    this.loading = true;

    this.transferenciaService.reenviarTransferencias(ids).subscribe({
      next: () => {
        this.toastService.sucesso('Reenviar', 'Registros reenviados com sucesso');
        this.transferenciasSelecionadas = [];
        this.recarregar();
      },
      error: (error) => {
        if (error.status === 409) {
          this.toastService.erro('Reenviar', 'Existe(m) registro(s) selecionado(s) que não está(ão) com status "Tentativas Excedida"');
        } else {
          this.toastService.erro('Reenviar', 'Erro ao reenviar os registros');
        }
      },
      complete: () => {
        this.loading = false;
      }
    });
  }
}
